import React from "react";
import { Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { Tooltip } from "@mui/material";
import { Button } from "@mui/material";
import ContrastIcon from "@mui/icons-material/Contrast";
import OpenWithIcon from "@mui/icons-material/OpenWith";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import StraightenIcon from "@mui/icons-material/Straighten";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

type ViewerToolsType = {
  children?: never[];
  handleActiveTool: (tool: string) => void;
};

export default function ViewerTools(props: ViewerToolsType): JSX.Element {
  const iconStyle = {
    m: { xs: 0.5, sm: 0.7, md: 0.7 },
    fontSize: { xs: 18, sm: 23, md: 25 },
  };
  const IconExplanations = [
    {
      name: "Wwwc",
      element: <ContrastIcon sx={{ ...iconStyle }} />,
    },
    {
      name: "Pan",
      element: <OpenWithIcon sx={{ ...iconStyle }} />,
    },
    {
      name: "Zoom",
      element: <ZoomInIcon sx={{ ...iconStyle }} />,
    },
    {
      name: "Length",
      element: <StraightenIcon sx={{ ...iconStyle }} />,
    },
    {
      name: "RectangleRoi",
      element: <CropSquareIcon sx={{ ...iconStyle }} />,
    },
    {
      name: "Eraser",
      element: <DeleteOutlineIcon sx={{ ...iconStyle }} />,
    },
  ];

  const [activeTool, setActiveTool] = React.useState("WWWc");

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    nextActiveTool: string
  ) => {
    setActiveTool(nextActiveTool);
    props.handleActiveTool(nextActiveTool);
  };

  //   const handleButton = (judge: boolean) => {
  //     if (judge === true) {
  //       return "contained";
  //     } else {
  //       return "outlined";
  //     }
  //   };

  return (
    <ToggleButtonGroup
      orientation="vertical"
      value={activeTool}
      exclusive
      onChange={handleChange}
    >
      {IconExplanations.map((Iconexp) => (
        <ToggleButton
          value={Iconexp.name}
          aria-label={Iconexp.name}
          sx={{
            p: 0,
            border: 0,
            borderRadius: 0,
            color: "#2278CF",
            "&.Mui-selected": {
              backgroundColor: "#2278CF",
              color: "white",
              "&:hover": {
                color: "#ddd",
                backgroundColor: "#1b60a5",
              },
            },
          }}
        >
          <Tooltip title={Iconexp.name} placement="left" sx={{ m: 1 }}>
            {Iconexp.element}
          </Tooltip>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>

    // <Grid display={{md:'flex',xs:'flex-row'}} gap={{md:1}} ml={1} >
    //     {IconExplanations.map(Iconexp => {
    //         return(
    //             <Tooltip title={Iconexp.name}>
    //             <Button variant={handleButton(Iconexp.name===activeTool)}
    //             onClick={()=>
    //                 {setActiveTool(Iconexp.name)
    //                 props.handleActiveTool(Iconexp.name)}}
    //             >
    //                 {Iconexp.element}
    //             </Button>
    //         </Tooltip>
    //         )
    //     })}
    // </Grid>
  );
}
